import { ListModel } from "../../../shared/components/list";

export class ListRowModel {

  public cells: Array<ListModel> = [];

  public classes: string;

}